import { render, staticRenderFns } from "./Toolbox.vue?vue&type=template&id=98dfc27c&scoped=true&"
import script from "./Toolbox.vue?vue&type=script&lang=ts&"
export * from "./Toolbox.vue?vue&type=script&lang=ts&"
import style0 from "./Toolbox.vue?vue&type=style&index=0&id=98dfc27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dfc27c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCard,VCardText,VDivider,VImg,VSlideGroup,VSlideItem})
